import { render, staticRenderFns } from "./MultiScanCompleted.vue?vue&type=template&id=623061a1&scoped=true&"
import script from "./MultiScanCompleted.vue?vue&type=script&lang=js&"
export * from "./MultiScanCompleted.vue?vue&type=script&lang=js&"
import style0 from "./MultiScanCompleted.vue?vue&type=style&index=0&id=623061a1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623061a1",
  null
  
)

export default component.exports